<template>
  <div class="app-notification">
    <div class="notification-card">
      <notification-icon :icon-type="iconType"/>
      <div class="notification-title">{{ title }}</div>
      <div class="notification-text">{{ text }}</div>
      <div v-if="hasButtons" v-for="button in notificationButtons" :key="button.title" class="button-container">
        <riseup-button class="riseup-button"
                          :action="button.action"
                          :size="button.size || 'small'"
                          :title="button.title"
                          :subtitle="button.subTitle"
                          :variant="button.variant"/>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import BaseUI from 'base-ui';
import NotificationIcon from './NotificationIcon.vue';

export default {
  name: 'AppNotification',
  components: {
    RiseupBot: BaseUI.RiseupBot,
    RiseupButton: BaseUI.RiseupButton,
    NotificationIcon,
  },
  props: {
    fromBoti: {
      type: Boolean,
      required: false,
      default: true,
    },
    title: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    notificationButtons: {
      type: Array,
      required: false,
      default: () => [],
    },
    iconType: {
      type: String,
      required: false,
      default: 'none',
    },
  },
  computed: {
    hasButtons() {
      return !_.isEmpty(this.notificationButtons);
    },
  },
};
</script>


<style lang="scss" scoped>
  @import '../../../../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../../../../scss/mixins';

  .app-notification {
    width: 100%;
    display: flex;
    justify-content: center;

    .notification-card {
      @include responsive-margin;
      display: inline-block;
      width: 100%;
      background-color: $riseup_white;
      box-shadow: 0 0 6px 0 $riseup_gray_1;
      border-radius: 3px;
      padding: 24px;

      .notification-title {
        font-family: GretaSans;
        font-size: 24px;
        font-weight: bold;
        line-height: 1.17;
      }

      .notification-text {
        font-size: 16px;
        margin-top: 13px;
        line-height: 1.5;
      }

      .button-container {
        width: 100%;
        margin-top: 16px;

        .riseup-button {
          width: 100%;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/responsive-pages/authenticated/navigation-pages/cashflow-app/notification/AppNotification.vue